import { UsuarioModel } from './../usuario/usuario.model';
export class GrupoClienteModel {
    id: number;
    descricao: String;
    usuario: UsuarioModel;
}



// WEBPACK FOOTER //
// /app/src/app/model/cliente/grupocliente.model.ts